import React from 'react'
import Alert from 'react-s-alert';
import { translate } from 'react-i18next';
import { Button } from '@material-ui/core';
import './Login.scss'
const LoginForm = ({ account, children, logo,target, handleSubmitLogin, handleChange, ...props }) => {
    const { t } = props;
    return (
        <div className='loginContainer'>
            <div className='loginContent'>
                <img className='loginLogo' src={logo} alt='Zaddons Logo' />
                <div className='loginFormContainer'>
                    <p className="text-center pv">{t('Login.title', { framework: "react-i18next" })}</p>
                    <form data-parsley-validate="" onSubmit={handleSubmitLogin} noValidate className="mb-lg">
                        <div className="form-group has-feedback">
                            <label htmlFor='username'>Username</label>
                            <input
                                id="username"
                                name="username"
                                type="text"
                                placeholder={t('Login.username', { framework: "react-i18next" })}
                                autoComplete="off"
                                onChange={handleChange}
                                required="required"
                                className="form-control"
                                value={account.username} />
                        </div>
                        <div className="form-group has-feedback">
                            <label htmlFor='password'>Password</label>
                            <input
                                id="password"
                                name="password"
                                type="password"
                                placeholder={t('Login.password', { framework: "react-i18next" })}
                                onChange={handleChange}
                                required="required"
                                className="form-control"
                                value={account.password} />
                        </div>
                        <Button
                            disabled={!target === ''}
                            type="submit"
                            className={`buttonSubmit`}
                        >
                            {t('Login.login', { framework: "react-i18next" })}
                        </Button>
                    </form>
                </div>
                <span>
                    {children}
                </span>
                <Alert stack={{ limit: 3 }} />
                <span className='copyRights'>{t('Login.copyRights', { framework: "react-i18next" })}</span>
            </div>
        </div>
    );
}
export default translate('common')(LoginForm);